var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgClock = function SvgClock(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#979797",
    fillRule: "evenodd",
    d: "M3 12c0-4.968 4.023-9 8.991-9C16.968 3 21 7.032 21 12s-4.032 9-9.009 9C7.023 21 3 16.968 3 12m1.8 0c0 3.978 3.222 7.2 7.2 7.2s7.2-3.222 7.2-7.2-3.222-7.2-7.2-7.2A7.2 7.2 0 0 0 4.8 12m6.3-4.5h1.35v4.725l4.05 2.403-.675 1.107L11.1 12.9z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgClock);
export default ForwardRef;